import React, { FunctionComponent, useState } from 'react';
import { t } from 'autobiz-translate';
import { AutobizButton } from 'autobiz-strap';
import { Alert } from 'reactstrap';
import { useNavigate } from 'react-router';
import { auth0Credentials } from '../../../../config';
import AccessValidationWrapper from './AccessValidationWrapper';

const EmailVerifyCode: FunctionComponent = () => {
    const [valid, setValid] = useState(false);
    const [code, setCode] = useState('');
    const [touched, setTouched] = useState(false);

    const searchParams = new URLSearchParams(document.location.search);

    const state = searchParams.get('state');
    const session = searchParams.get('session');
    const onboarding = searchParams.get('onboarding');
    const verifyEmail = searchParams.get('verifyEmail');
    const errMessage = searchParams.get('errMessage');
    const navigate = useNavigate();

    const { domain } = auth0Credentials;

    const handleCodeChange = (event: React.FormEvent<HTMLInputElement>) => {
        setTouched(true);
        const { value } = event.currentTarget;
        setCode(value.toUpperCase());
        setValid(value.length === 6);
    };

    let wrapperProps = {};

    if (onboarding === 'y') {
        wrapperProps = {
            currentStep: 1,
            title: t('welcome_office'),
            label: `${t('enter_email_verification_code')} ${verifyEmail}`,
        };
    } else {
        wrapperProps = {
            title: t('please_validate_your_email_title'),
            label: `${t('enter_email_verification_code')} ${verifyEmail}`,
        };
    }

    return (
        <AccessValidationWrapper {...wrapperProps}>
            <main>
                {errMessage && touched === false && (
                    <Alert color="danger" className="text-center">
                        {t(errMessage)}
                    </Alert>
                )}

                <form method="get" action={`https://${domain}/continue`}>
                    <label htmlFor="email">{t('set_code')}</label>
                    <input
                        type="text"
                        name="verifyCode"
                        className="form-control"
                        value={code}
                        onChange={handleCodeChange}
                        style={{
                            fontSize: '30px',
                            textAlign: 'center',
                            margin: 'auto',
                        }}
                        maxLength={6}
                    />

                    <a href="#" className="small" onClick={() => navigate('/dashboard')}>
                        {t('modify_my_email')}
                    </a>

                    <input type="hidden" name="state" value={state || ''} />
                    <input type="hidden" name="verifyEmail" value={verifyEmail || ''} />
                    <input type="hidden" name="session" value={session || ''} />
                    <input type="hidden" name="onboarding" value={onboarding || ''} />
                    <AutobizButton type="submit" block color="primary" disabled={!valid}>
                        {t('continue')}
                    </AutobizButton>
                </form>
            </main>
        </AccessValidationWrapper>
    );
};

export default EmailVerifyCode;
